/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { ImportDropzone } from './ImportDropzone';
import Divider from '@mui/material/Divider';
import DialogButton from '../../ui/utils/DialogButton';

export function StartImportDialog(props) {
	const [hide, setHide] = useState(false);

	useEffect(() => {
		if (props.open) {
			setHide(false);
		}
	}, [props.open]);

	if (!props.open) {
		return null;
	}
	// useEffect(() => {

	// })
	return (
		<Dialog fullWidth open={props.open} onClose={props.onClose} style={{ visibility: hide ? 'hidden' : undefined }}>
			<DialogTitle>
				<FormattedMessage id="DialogImport.title" defaultMessage="Import" />
			</DialogTitle>
			<DialogContent>
				<ImportDropzone
					enableClick
					scopeId={props.scopeId}
					onDone={props.onClose}
					onImporting={() => setHide(true)}
				>
					<div
						style={{
							minWidth: 300,
							minHeight: 300,
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							margin: '16px 0px',
							border: 'dashed'
						}}
					>
						<FormattedMessage
							id="Import.StartDialog.DropZone.Message"
							defaultMessage="Drop file or click to select."
						/>
					</div>
				</ImportDropzone>
			</DialogContent>
			<Divider />
			<DialogActions>
				<DialogButton margin onClick={props.onClose}>
					<FormattedMessage id="Cancel" defaultMessage="Cancel" />
				</DialogButton>
			</DialogActions>
		</Dialog>
	);
}

StartImportDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired
};
